import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyles = createUseStyles(({ breakpoints, type }: CmsWrenchTheme) => {
  const mediaQueryMD = `@media (min-width: ${breakpoints.md}px)`;

  return {
    mainGrid: {
      display: 'flex',
      minHeight: '370px',
      maxWidth: '850px',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '20px',
      [mediaQueryMD]: {
        flexDirection: 'row',
        marginBottom: '200px',
      },
    },
    pageContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      gap: '16px',

      '& h1': {
        fontSize: type.fontSize.cardTitle,
        textAlign: 'center',
        [mediaQueryMD]: {
          fontSize: type.fontSize.pageTitle,
          textAlign: 'left',
        },
      },
      '& span': {
        fontSize: type.fontSize.bodySm,
        textAlign: 'center',
        [mediaQueryMD]: {
          fontSize: type.fontSize.body,
          textAlign: 'left',
        },
      },
      [mediaQueryMD]: {
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        textAlign: 'left',
        padding: '0 20px 0 0',
        marginTop: '12px',
      },
    },
    pathImage: {
      maxWidth: '305px',
      order: 1,
      height: '230px',
      padding: '10px',
      objectFit: 'contain',
      [mediaQueryMD]: {
        marginRight: '60px',
        order: 0,
      },
    },
  };
});

export default useStyles;
